module.exports = __webpack_public_path__ + "a6a5ea93b96e359f2ce95bbfa7c35a32.MP3";